import { axiosIns } from "../services";
import { get } from "../services/HttpService";

export class CustomVirtualAccountLedger {
  constructor(ledgerObject = {}) {
    this.set(ledgerObject);
  }

  static validations = {
    id: [],
    uuid: [],
    created_at: [],
  };

  /**
   * @memberof CustomVirtualAccountLedger
   * @type API
   * @returns Promise
   */
  static list = (queryData = {}, config = {}) => {
    return get(
      `v1/insta-collect/internal/virtual_accounts/ledger/`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400,
    }));
  };

  /**
   * @memberof CustomVirtualAccountLedger
   * @type API
   * @returns Promise
   */
    static list_v2 = (queryData = {}, config = {}) => {
      return get(
        `v2/insta-collect/internal/virtual_accounts/ledger/`,
        queryData,
        config
      ).catch((error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      }));
    };

  /**
   * @memberof CustomVirtualAccountLedger
   * @type API
   * @returns Promise
   */
  static report_download = (queryData = {}, config = {}) => {
    return axiosIns
      .request({
        url: "v1/insta-collect/internal/virtual_accounts/ledger/report_download/",
        method: "POST",
        responseType: "blob",
        data: queryData,
        headers: config.headers,
      })
      .catch((error) => ({
        success: false,
        data: "Something went wrong",
        status: 500,
      }));
  };

  /**
   * @memberof CustomVirtualAccountLedger
   * @type Setter Method
   * @takes Ledger Params
   * @returns void
   */
  set = (values) => {
    Object.keys(values).forEach((x) => (this[x] = values[x]));
  };
}
